import React from 'react';
import { Table, ChartData } from '@scholastic/volume-react';
import { transformTableData } from './ReportTable.transformer';
import './ReportTable.scss';

export interface ReportTableProps {
  /**
   * It will old the raw table data
   */
  tableData?: ChartData;
}

const ReportTable = ({ tableData }: ReportTableProps) => {
  const chartTableData = transformTableData(tableData);
  return (
    <Table
      dataSet={chartTableData}
      className={'stats-chart-table'}
      striped={true}
      bordered={true}
      darkTheme={false}
    />
  );
};

export default ReportTable;
